import Vue from 'vue'
import VueGtm from '@gtm-support/vue2-gtm'
import router from '../router'

const mode = process.env.NODE_ENV
const { id, queryParams } = process.env.common.gtm

Vue.use(VueGtm, {
  id, // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
  queryParams, // Add URL query string when loading gtm.js with GTM ID (required when using custom environments)
  compatibility: true, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
  debug: mode == 'local', // Whether or not display console logs debugs (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
})
